module.exports = __webpack_public_path__ + "static/media/profile2.4fda8850.jpeg";